// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__HH0HZ","disabled":"FileBtn_disabled__qmWVy","warn":"FileBtn_warn__Shlya","fade":"FileBtn_fade__1XpEf"};